import updateReadFlag from "./readFlagUpdate.api";
import { getUnprocessClaimNotification } from "../notification/getUnprocessClaimNotification.api";
import { getUnprocessMasterListNotification } from "./getUnprocessMasterListNotification.api";
import { getUnprocessShippingOrderNotification } from "./getUnprocessShippingOrderNotification.api";
import {getUnprocessPrifeClaimNotification} from "./getUnprocessPrifeClaimNotification";
import getPurchaseOrderNotification from "./getPurchaseOrderNotification.api";

const notificationApi = {
  getUnprocessPrifeClaimNotification,
  getUnprocessClaimNotification,
  getUnprocessMasterListNotification,
  getUnprocessShippingOrderNotification,
  updateReadFlag,
  getPurchaseOrderNotification,
};

export default notificationApi;
